module.exports = __webpack_public_path__ + "img/bh.ef135f3c.svg";